module.exports = __webpack_public_path__ + "static/img/partner-logo6.1e6fb2c3.jpg";